<template>
  <div class="rightContent">
    <div class="right-con">
      <!--创建答题-->
      <el-scrollbar style="height: 100%" ref="scrollbarRef">
        <!--答题预览-->
        <div class="questionnaire-view">
          <h1 class="border-f1">
            <img src="../../../svg/forceanswer.svg" v-show="forceAnswer" class="forceanswer-icon" />
            【{{ $t(`showInfo.${questionType}`) }}】{{ answerSheetTitle }}
            <!-- <i v-if="questionNaireState == 0" class="black">未发布</i>
            <i class="green" v-if="questionNaireState == 1">进行中</i>
            <i class="black" v-if="questionNaireState == 2">{{$t('showInfo.已终止')}}</i>
            <i class="black" v-if="questionNaireState == 4">已结束</i> -->
            <span v-if="questionNaireState == 1 && duration > 0" class="time">
              {{ duration }} S</span
            >
          </h1>

          <div class="answer-item" style="clear: both">
            <!-- <h2>【{{ questionType }}】{{ title }}</h2> -->
            <ul>
              <template v-if="questionNaireState == 0">
                <li
                  v-for="(item, sub) in normalOptions"
                  :key="sub"
                  :class="{ 'item-right': item.successState }"
                >
                  {{ `${item.number}.${item.item}` }}
                  <template v-if="item.successState">
                    <img src="../../../svg/correct.svg" width="14px" height="14px" />
                  </template>
                </li>
              </template>
              <template v-else>
                <div v-for="(item, sub) in optionSelectInfoList" :key="sub" class="fontColor">
                  <li
                    :class="{ 'item-right': item.successState }"
                    :style="{
                      backgroundSize: `${item.selectPeoplePercent}% 100%`
                    }"
                  >
                    {{ `${item.number}.${item.item}` }}
                    <template v-if="item.successState">
                      <img src="../../../svg/correct.svg" width="14px" height="14px" />
                    </template>
                  </li>
                  {{ item.selectCount }}{{ $t('showInfo.人') }}（{{ item.selectPeoplePercent }}% ）
                </div>
              </template>
            </ul>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div class="bottom-bar">
      <div v-if="questionNaireState == 0" class="new questionnaire-control">
        <div>
          <span class="answer-limit" :class="{ 'answer-limit-show': timeLimitSwitch }">
            <span class="fontColor"
              ><el-switch v-model="timeLimitSwitch"></el-switch>{{ $t('showInfo.答题限时') }}</span
            ><span v-if="timeLimitSwitch"
              ><input
                v-model="timeLimitVal"
                :placeholder="$t('showInfo.请输入内容')"
                class="limit"
              />{{ $t('showInfo.秒') }}</span
            >
          </span>
        </div>
        <div>
          <template>
            <el-popover placement="top" width="180" v-model="visibleDel" height="160">
              <p>
                <img src="../../../svg/icon-tips.svg" width="15px" height="15px" />{{
                  $t('showInfo.确定删除这份答题卡吗')
                }}
              </p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visibleDel = false">{{
                  $t('showInfo.取消')
                }}</el-button>
                <el-button type="primary" size="mini" @click="deletQuestionnaireApiFunc">{{
                  $t('showInfo.确定')
                }}</el-button>
              </div>
              <a
                slot="reference"
                class="btn-sm btn-red-outline btn-modal-reconfirm"
                href="javascript:;"
                >{{ $t('showInfo.删除') }}</a
              >
            </el-popover>
          </template>
          <a class="btn-sm btn-blue-outline" @click="editQuestionnaire" href="javascript:;">{{
            $t('showInfo.编辑')
          }}</a>
          <a class="link-blue save-blue" href="javascript:;" @click="releaseQuestionnaireFunc">{{
            $t('showInfo.发布答题卡')
          }}</a>
        </div>
      </div>
      <div class="end" v-if="questionNaireState == 2 || questionNaireState == 4">
        <div>
          <span
            v-show="['单选', '多选'].includes(questionType)"
            style="margin-left: 8px"
            class="fontColor"
            >{{ $t('showInfo.答题人数') }}: <font class="font-red">{{ answerPeopleCount }}</font>
            {{ $t('showInfo.人') }} {{ $t('showInfo.正确人数') }}:
            <font class="font-red">{{ successCount }}</font> {{ $t('showInfo.人') }}
            {{ $t('showInfo.正确率') }}：<font class="font-red"
              >{{ answerCorrectPercent }}%</font
            ></span
          >
          <span v-show="questionType == this.$t('showInfo.评分')" style="margin-left: 8px"
            >{{ $t('showInfo.平均分') }}: <font class="font-red">{{ averageScore }}</font>
            {{ $t('showInfo.分') }}</span
          >

          <a class="down-answer" href="javascript:;" @click="downloadAnswer">{{
            $t('showInfo.下载结果')
          }}</a>
        </div>
        <a
          class="link-blue save-blue save-answer"
          href="javascript:;"
          v-if="questionNaireState == 2"
          @click="sendResultFunc"
          >{{ $t('showInfo.发布结果') }}</a
        >
        <span v-if="questionNaireState == 4" class="font-blue published-answer">{{
          $t('showInfo.结果已发布')
        }}</span>
      </div>
      <div v-if="questionNaireState == 1" class="end">
        <div>
          <span class="font-12 m-r-8 fontColor"
            >{{ $t('showInfo.答题人数') }}: <font class="font-red">{{ answerPeopleCount }}</font>
            {{ $t('showInfo.人') }} </span
          ><span class="fontColor">
            {{ $t('showInfo.正确人数') }}: <font class="font-red">{{ successCount }}</font>
            {{ $t('showInfo.人') }}</span
          >
        </div>
        <template>
          <el-popover placement="top" width="180" v-model="visibleFinish" height="160">
            <p>{{ $t('showInfo.确定结束这份答题卡吗') }}</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visibleFinish = false">{{
                $t('showInfo.取消')
              }}</el-button>
              <el-button type="primary" size="mini" @click="finishReleaseApiFunc">{{
                $t('showInfo.确定')
              }}</el-button>
            </div>
            <a slot="reference" class="btn-sm btn-red-finish btn-modal-reconfirm">{{
              $t('showInfo.结束答题')
            }}</a>
          </el-popover>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
let moreAnswerSerial = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
import axios from 'axios';
import {
  getwebcastAnswerSheet,
  deletAnswerSheetApi,
  releaseAnswerSheet,
  finishAnswerApi,
  sendQuestionResult,
  getAnswerSheetId
} from '@/api/liveRequest/answerApi';
import { pushRoomMessageFunc } from '@/utils/socketMessageDispose';
import { getConfPaperId } from '@/api/liveRequest/questionnaireApi';
export default {
  inject: ['questionThis'],
  props: {
    actionTabsObj: {
      type: Object,
      default: () => {
        return null;
      }
    },
    showInfoState: {
      type: Boolean,
      default: false
    },
    answerId: {
      type: String,
      default: ''
    },
    confAnswerId: {
      type: String,
      default: ''
    }
  },
  watch: {
    answerId: {
      immediate: true,
      handler(value) {
        if (value) {
          console.log(value, 'webcastAnswerSheetId');
          this.confId = value;
          this.confAnswerSheetId = this.confAnswerId;
          if (this.confAnswerId != 0) {
            this.getAnswerSheetId();
          } else {
            this.getPaperInfoFuncs();
          }
        }
      }
    }
  },
  data() {
    return {
      itemNum: 3, //答题人数
      dataList: [],
      type: '',
      title: '',
      answerSheetTitle: '',
      options: {
        0: this.$t('showInfo.单选'),
        1: this.$t('showInfo.多选'),
        2: this.$t('showInfo.问答')
      },
      hintDialogVisible: false,
      hintState: '',
      loadingState: false,
      questionNaireState: '0',
      answerPeopleCount: 0,
      confPaperId: null,
      confId: '',
      firstRelease: true,
      visibleDel: false,
      visibleFinish: false,
      editPaperObject: {},
      headcount: 0,
      rightAnswers: [],
      questionType: '',
      averageScore: '',
      normalOptions: [],
      optionSelectInfoList: [],
      timeLimitSwitch: false,
      confAnswerSheetId: '',
      countdownVal: 30,
      timeLimitVal: 30,
      timeOutRet: null,
      successCount: 0,
      sendResultFuncLock: false,
      isSendAnswer: false,
      answerCorrectPercent: '',
      duration: 0,
      forceAnswer: false
    };
  },
  computed: {
    moreAnswerSerialArray() {
      return moreAnswerSerial;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    liveId() {
      return this.$store.getters.liveId;
    }
  },
  mounted() {
    //收到聊天室消息
    pushRoomMessageFunc((msg) => {
      this.getCvMcRoomMessage(msg);
    });
  },
  methods: {
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7127: {
          this.disposeCustomMessage_7127(msg.requestData);
          break;
        }
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case 'paper/state': {
            console.log('7107答题-------请求', requestData);
            this.confPaperId = requestData.confPaperId;
            this.questionNaireState = requestData.state;
            this.$emit('refreshList', true);
            this.getAnswerSheetId();
            break;
          }
          case 'answersheet': {
            console.log(requestData, 'requestData');
            if (this.confPaperId == requestData.confPaperId) {
              this.questionNaireState = requestData.state;
              this.$emit('refreshList', true);
            }
            break;
          }
        }
      }
    },
    /**处理7127消息内容体 */
    disposeCustomMessage_7127(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case 'answersheet/submit': {
            if (
              this.confAnswerSheetId != 0 &&
              this.confAnswerSheetId == requestData.confAnswerSheetId
            ) {
              this.getAnswerSheetId();
            }
            break;
          }
        }
      }
    },
    /**下载模板 */
    downloadFunc() {
      axios({
        url: `${process.env.VUE_APP_BASE_API}handler/v1/paper/export/${this.confPaperId}`,
        responseType: 'arraybuffer',
        method: 'get'
      })
        .then((res) => {
          console.log(res, 'downloadFunc');
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', this.$t('showInfo.问卷结果') + '.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t('showInfo.文件下载失败'));
        });
    },
    /** 获取答题统计信息 */
    getConfPaperIdFunc() {
      console.log('confPaperId', this.confAnswerSheetId);
      //this.loadingState = true;
      getConfPaperId(
        {
          confAnswerSheetId: this.confAnswerSheetId
        },
        this.$store.getters.liveToken
      )
        .then((res) => {
          console.log(res, 'getConfPaperId');
          if (res.code === 200) {
            let _data = res.data;
            this.title = _data.title;
            this.questionNaireState = _data.state;
            this.answerPeopleCount = _data.answerPeopleCount;
            this.dataList = _data;
          }
          //this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, 'err_getConfPaperId');
          //this.loadingState = false;
        });
    },
    /** 编辑答题 */
    editQuestionnaire() {
      this.$emit('editPaper', this.editPaperObject);
    },
    /**结束发布 */
    finishRelease() {
      this.hintState = 'finish';
      this.hintDialogVisible = true;
    },
    /** 结束发布答题函数*/
    finishReleaseApiFunc() {
      finishAnswerApi({ id: this.confId }, this.$store.getters.liveToken).then((res) => {
        console.log(res, 'res_finishRelease');
        if (res.code === 200) {
          //this.actionTabsObj.confPaperId = this.confPaperId;
          this.$emit('refreshList', true);
          this.getAnswerSheetId();
        } else {
          this.$message.error(this.$t('showInfo.结束发布答题失败'));
        }
        this.visibleFinish = false;
      });
      // .catch((err) => {
      //   console.log(err, "err_finishRelease");
      //   this.$message.error("结束发布问卷失败！");
      // });
    },
    /**删除答题 */
    deleteQuestionnaire() {
      this.hintState = 'delete';
      this.hintDialogVisible = true;
    },
    deletQuestionnaireApiFunc() {
      console.log(this.confId, 'this.confId');
      deletAnswerSheetApi(this.confId, this.$store.getters.liveToken)
        .then((res) => {
          console.log(res, 'res_deletQuestionnaireApi');
          if (res.code === 200) {
            this.$emit('deleteTo', true);
          }
          this.visibleDel = false;
        })
        .catch((err) => {
          console.log(err, 'err_deletQuestionnaireApi');
        });
    },
    /** */
    hintDialogCancel() {
      this.hintDialogVisible = false;
    },
    /** 获取答题详情 */
    getPaperInfoFuncs() {
      console.log(this.confId, '...............');
      getwebcastAnswerSheet(this.confId, this.$store.getters.liveToken)
        .then((res) => {
          if (res.code === 200) {
            let _data = res.data;
            this.answerSheetTitle = _data.answerSheetTitle;
            this.title = _data.title;
            this.questionType = _data.questionType;
            this.rightAnswers = _data.rightAnswers;
            this.questionNaireState = _data.answerSheetStateV2;
            this.successCount = _data.answerCorrectCount;
            this.averageScore = _data.averageScore;
            this.answerCorrectPercent = _data.answerCorrectPercent;
            this.answerPeopleCount = _data.answerPeopleCount;
            this.forceAnswer = _data.forceAnswer;
            //this.duration = _data.duration;
            if (_data.options) {
              this.normalOptions = _data.options;
              if (_data.questionType == '单选' || _data.questionType == '多选') {
                this.normalOptions = this.parseData(_data.options, _data.rightAnswers);
              }
            }
            console.log(res.data, "paper返回");
            this.editPaperObject = res.data;
          } else {
            this.$message.error(res.data.msg);
          }
          //this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, 'err_getPaperInfo');
        });
    },
    /**倒计时 */
    countdownFunc() {
      if (this.timeOutRet) clearTimeout(this.timeOutRet);
      this.timeOutRet = setTimeout(() => {
        if (this.duration > 0) {
          this.duration--;
          this.countdownFunc();
        } else {
          this.getAnswerSheetId();
          this.$emit('refreshList', true);
          clearTimeout(this.timeOutRet);
        }
      }, 1000);
    },
    releaseQuestionnaireFunc() {
      if (this.timeLimitVal < 10 || this.timeLimitVal > 999) {
        this.$message.error(this.$t('showInfo.答题限时允许输入范围10-999'));
        return;
      }
      let data = {
        webcastAnswerSheetId: this.confId
      };
      if (this.timeLimitSwitch) {
        data.duration = this.timeLimitVal;
      }
      // 发布答题
      releaseAnswerSheet(data, this.$store.getters.liveToken)
        .then((res) => {
          console.log(res, 'res_releaseQuestionnaire');
          if (res.code === 200) {
            this.confAnswerSheetId = res.data.confAnswerSheetId;
            //this.duration = res.data.duration;
            this.$emit('refreshList', true);
            this.getAnswerSheetId();
            this.countdownFunc();
          } else {
            this.$message.error(res.msg);
          }
          this.visibleDel = false;
        })
        .catch((err) => {
          console.log(err, 'err_releaseQuestionnaire');
        });
    },

    EndQuestionnaire() {
      // 结束
      let tabs = this.editableTabs;
      tabs.forEach((tab) => {
        if (tab.name === this.editableTabsValue) {
          tab.type = 'stop';
        }
      });
      this.editableTabs = tabs;
      let num = this.editableTabsValue * 1 - 2;
      this.TabsHistory[num].type = 'stop';
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index - 1] || tabs[index + 1];
            if (nextTab) {
              activeName = nextTab.name;
            } else {
              activeName = '1';
            }
          }
        });
      }
      this.editableTabsValue = activeName;
      console.log('ok' + this.editableTabsValue);
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
    editIng(index) {
      // 重新編輯
      console.log(index);
      let number = this.editableTabsValue * 1 - 2;
      let list = this.TabsHistory[number].content;
      this.removeTab(index);
      this.AnswerList = [];
      this.AnswerList = list;
      this.tabIndex = this.AnswerList.length;
      this.editableTabsValue = '1';
    },
    /**下载结果 */
    downloadAnswer() {
      axios({
        url: `${config.cpp}handler/v1/answerSheet/export/question/front_result/${this.confAnswerSheetId}`,
        responseType: 'arraybuffer',
        headers: {
          token: this.$store.getters.liveToken
        },
        method: 'get'
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', this.$t('showInfo.答题结果') + '.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          if (JSON.stringify(err).includes('4001')) {
            this.$message.warning(this.$t('showInfo.该答题卡内容已更新，请刷新后再试'));
          } else {
            this.$message.error(this.$t('showInfo.文件下载失败'));
          }
        });
    },
    sendResultFunc() {
      sendQuestionResult(this.confAnswerSheetId, this.$store.getters.liveToken)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(this.$t('showInfo.答题结果下发成功'));
            this.getAnswerSheetId();
            this.$emit('refreshList', true);
            this.isSendAnswer = true;
          } else if (res.code === 4001) {
            this.$message.warning(this.$t('showInfo.该答题卡内容已更新，请刷新后再试'));
          } else {
            this.$message.success(this.$t('showInfo.答题结果下发失败'));
          }
        })
        .catch((err) => {
          console.log(err, 'err-sendQuestionResult');
          this.$message.success(this.$t('showInfo.答题结果下发失败'));
        });
      setTimeout(() => {
        this.sendResultFuncLock = false;
      }, 3000);
    },
    getAnswerSheetId() {
      if (this.confAnswerSheetId == 0) {
        return false;
      }
      getAnswerSheetId(this.confAnswerSheetId, this.$store.getters.liveToken)
        .then((res) => {
          // console.log(res, "getAnswer-----");
          if (res.code === 200) {
            let _data = res.data;
            this.answerSheetTitle = _data.answerSheetTitle;
            this.title = _data.questionTitle;
            this.questionType = _data.questionType;
            this.questionNaireState = _data.answerSheetStateV2;
            this.successCount = _data.answerStatisticsVO.answerCorrectCount;
            this.averageScore = _data.answerStatisticsVO.averageScore;
            this.rightAnswers = _data.answerStatisticsVO.rightAnswers;
            this.answerPeopleCount = _data.answerPeopleCount;
            this.answerCorrectPercent = _data.answerStatisticsVO.answerCorrectPercent;

            this.duration = _data.duration;
            this.forceAnswer = _data.forceAnswer; //新增强制回答
            this.optionSelectInfoList = this.parseData(
              _data.answerStatisticsVO.optionSelectInfoList,
              _data.answerStatisticsVO.rightAnswers
            );
          } else {
            this.$message.error(this.$t('showInfo.获取失败'));
          }
          //this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, 'err_getPaperInfo');
        });
    },
    parseData(data, right) {
      let list = data;
      list.forEach((item) => {
        if (right.includes(item.number)) {
          item.successState = true;
        }
      });
      return list;
    }
  }
};
</script>
<style scoped lang="scss">
.rightContent {
  height: 480px;
  width: 100%;
  background: $back-answer-color;
  padding: 20px 0 20px 0;
  font-size: 16px;
  color: $white-color;
}
.right-con {
  height: 440px;
  text-align: left;
  font-size: 12px;
}
.btn-sm {
  cursor: pointer;
}
.hintDialogBody {
  min-height: 44px;
  padding: 8px 9px 0 9px;
  font-size: 12px;
  color: #333333;
}
.hintDialogButtton {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.hintDialog ::v-deep .el-dialog__body {
  padding: 16px 15px;
}
.hintDialog {
  display: flex;
  align-items: center;
}
.question-item {
  h2 {
    font-size: 12px;
    font-weight: normal;
    line-height: 24px;
  }
}
.questionnaire-view {
  padding-right: 15px;
  margin-left: 20px;
}

.questionnaire-view .question-item .question li {
  /* background-image: url("../../../../assets/li-cur-bg.png"); */
  background-size: 0% 100%;
  background-repeat: no-repeat;
}
.questionnaire-view .question li {
  min-height: 18px;
}
.questionnaire-view .question li span {
  position: absolute;
  left: 320px;
}
.questionnaire-view h1 {
  margin-bottom: 15px;
  font-size: 12px;
  font-weight: normal;
}
.questionnaire-view h1 i.red {
  background-color: #ff3300;
  color: #ffffff;
}
.questionnaire-view h1 i.black {
  background-color: #666666;
  color: #ffffff;
}
.questionnaire-view h1 i.green {
  background-color: $green3-color;
  color: #ffffff;
}
.questionnaire-view h1 i.grey {
  background-color: #dddddd;
  color: #ffffff;
}
.questionnaire-view h1 i {
  font-size: 12px;
  font-weight: normal;
  display: inline-block;
  vertical-align: middle;
  padding: 1px 6px;
  margin-left: 8px;
  border-radius: 2px;
}
.questionnaire-view ul li {
  display: inline-block;
  background: #5f6179;
  border-radius: 20px;
  margin: 4px 0;
  padding: 8px 16px;
  width: 60%;
  position: relative;
}
[data-theme='Orange'] .questionnaire-view ul li {
  background: #f0f0f0;
  color: #3e3f41;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.btn-sm {
  margin-top: 8px;
  border-radius: 4px;
  height: 28px;
  line-height: 28px;
  margin-left: 15px;
  font-size: 12px;
  display: inline-block;
  padding: 0 20px;
}
.btn-red-outline {
  border: 1px solid $red-color;
  color: $red-color;
  background: transparent;
  text-decoration: none;
}
.btn-blue-outline {
  border: 1px solid $bule-color;
  color: $bule-color;
  text-decoration: none;
}
.btn-blue-publish {
  border: 1px solid $bule-color;
  background: $bule-color;
}
.btn-red-finish {
  background: $red-color;
  margin-right: 40px;
}
.limit {
  border: 1px solid #7D7F8C;
  width: 47px;
  height: 18px;
  padding: 5px;
  margin-left: 5px;
  margin-right: 5px;
  background: $back-answer-color;
  color: $white-color;
}
::v-deep input:focus{
  outline: none;
}
[data-theme='Orange'] .limit {
  background: #fff;
  color: #606266;
}
.link-blue {
  color: $bule-color;
  text-decoration: none;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  padding: 0 15px;
  border-radius: 8px;
  margin-right: 15px;
  margin-left: 15px;
  border: 1px solid $bule-color;
}
.down-answer {
  color: $bule-color;
  text-decoration: none;
  display: inline-block;
  margin-left: 15px;
}
[data-theme='Orange'] .down-answer {
  color:#F89B33;
}
.save-blue {
  background-color: rgba(57, 134, 238, 1);
  color: $white-color !important;
  display: inline-block;
  margin-left: 15px;
}
.save-answer {
  margin-left: 5px;
}
.bottom-bar {
  font-size: 12px;
  margin-left: 20px;
}
.answer-item h2 {
  font-size: 12px;
}
.item-right img {
  float: right;
}
.time {
  width: 40px;
  height: 40px;
  border-radius: 30px;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $blue2-color;
  margin-right: 20px;
}
.font-blue {
  color: $bule-color;
}
.questionnaire-control {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.answer-limit {
  display: inline-block;
  margin-right: 110px;
}
.answer-limit-show {
  margin-right: 29px;
}
[data-theme='Orange'] .answer-limit {
  color:#5f6179;
}
.end {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.forceanswer-icon {
  vertical-align: top;
}
// .down-answer {
//   margin-left: 80px;
// }
.published-answer {
  margin-right: 20px;
}
::v-deep .el-switch {
  margin-right: 7px;
}
</style>
<style lang="scss">
.el-popover {
  background: $back-answer-color;
  color: rgba(255, 255, 255, 0.65);
  border: 1px solid $back-answer-color;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
}
.el-popper[x-placement^='top'] .popper__arrow,
.el-popper[x-placement^='top'] .popper__arrow::after {
  border-top-color: $back-answer-color;
}
.el-switch__core {
  background: $switch-color;
  border: 1px solid $switch-color;
}
</style>
